<template>
  <div class="council-report-component">
    <vue-form ref="form" :options="{ permalink: 'generateCouncilReport' }">
      <div class="card-header" slot="title">Generate Report</div>
    </vue-form>
  </div>
</template>

<script>
import VueForm from '@/components/Form'

export default {
  name: 'CouncilReport',
  components: {
    VueForm
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/CouncilReport.vue